module.exports = __webpack_public_path__ + "img/package.966e3cad.svg";